const buildPhotoUrl = (baseUrl, filePath) => {
  if (!filePath) return '';

  const rawPath = String(filePath).trim();
  if (!rawPath) return '';

  if (/^https?:\/\//i.test(rawPath)) {
    return rawPath;
  }

  let safeBase = String(baseUrl || '').replace(/\/+$/, '');
  const safePath = rawPath.replace(/^\/+/, '');

  // Some environments configured photosEndpoint as ".../photos", but
  // uploaded files are publicly served from ".../storage/...".
  if (safePath.startsWith('storage/') && /\/photos$/i.test(safeBase)) {
    safeBase = safeBase.replace(/\/photos$/i, '');
  }

  if (!safeBase) return `/${safePath}`;

  return `${safeBase}/${safePath}`;
};

export default buildPhotoUrl;
